(function ($) {
    $(function () {

        $('#findYourFitStickyClose').on('click', function () {
            Cookies.remove('fyfsticky');
            $('#findYourFitSticky').remove();   
        });

        var emailLink = $('.header-buttons a:contains("Email My Results")');
        if (emailLink.length > 0) {
            var resultsLink = encodeURIComponent(window.location.href);
            emailLink.attr("href", "mailto:?subject=Endicott College Find Your Fit Results&body=Here are my results " + resultsLink);
        }

    });
})($JQ);